<template>
  <v-layout row wrap style="height: 100%">
    <v-flex xs12 lg8 xl6>
      <v-layout column align-content-start style="height: 100%">
        <v-tabs>
          <v-tab href="#tab-outbound">Outbound</v-tab>
          <v-tab href="#tab-return">Return</v-tab>

          <v-tab-item value="tab-outbound">
            <v-card flat tile>
              <v-data-table
                hide-default-footer
                style="width: 100%"
                :headers="headers"
                :items="repeatService.repeatServiceModel.trip_a.changes"
                :expand="expand"
                ref="bookingSummaryList"
                :show-expand="true"
              >
                <template v-slot:item="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td>
                      <v-icon>expand_more</v-icon>
                    </td>
                    <td>
                      <p>{{props.item.created_date}}</p>
                    </td>
                    <td>
                      <p>{{typeDescriptions[props.item.type]}}</p>
                    </td>
                    <td>
                      <p>{{props.item.notes}}</p>
                    </td>
                    <td>
                      <p v-if="props.item.forced == true">{{props.item.forced}}</p>
                    </td>
                    <td>
                      <p v-if="props.item.recover_trips == true">{{props.item.recover_trips}}</p>
                    </td>
                    <td>
                      <p>{{props.item.changes.length}}</p>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-layout pa-2>
                    <ul>
                      <li v-for="event in props.item.changes">
                        <span>
                          {{event.field}} changed from
                          <b>{{ event.old_value }}</b>&nbsp;to
                          <b>{{ event.new_value }}</b>
                        </span>
                      </li>
                    </ul>
                  </v-layout>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-return">
            <v-card flat tile>
              <v-data-table
                style="width: 100%"
                :headers="headers"
                v-if="repeatService.repeatServiceModel.trip_b != null"
                :items="repeatService.repeatServiceModel.trip_b.changes"
                :expand="expand"
                ref="bookingSummaryList"
                :show-expand="true"
              >
                <template v-slot:item="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td>
                      <v-icon>expand_more</v-icon>
                    </td>
                    <td>
                      <p>{{props.item.created_date}}</p>
                    </td>
                    <td>
                      <p>{{typeDescriptions[props.item.type]}}</p>
                    </td>
                    <td>
                      <p>{{props.item.notes}}</p>
                    </td>
                    <td>
                      <p v-if="props.item.forced == true">{{props.item.forced}}</p>
                    </td>
                    <td>
                      <p v-if="props.item.recover_trips == true">{{props.item.recover_trips}}</p>
                    </td>
                    <td>
                      <p>{{props.item.changes.length}}</p>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-layout pa-2>
                    <ul>
                      <li v-for="event in props.item.changes">
                        <span>
                          {{event.field}} changed from
                          <b>{{ event.old_value }}</b>&nbsp;to
                          <b>{{ event.new_value }}</b>
                        </span>
                      </li>
                    </ul>
                  </v-layout>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Changelog",
  model: {
    prop: "content",
    event: "input"
  },
  components: {},
  props: {
    repeatService: Object
  },
  computed: {},
  mounted: function() {},
  data() {
    return {
      tab: null,
      expand: false,
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "expand"
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date"
        },
        {
          text: "Type",
          align: "left",
          sortable: false,
          value: "type"
        },
        {
          text: "Notes",
          align: "left",
          sortable: false,
          value: "notes"
        },
        {
          text: "Reset/Force Apply",
          align: "left",
          sortable: false,
          value: "notes"
        },
        {
          text: "Recover",
          align: "left",
          sortable: false,
          value: "notes"
        },
        {
          text: "No. Of Changes",
          align: "left",
          sortable: false,
          value: "changes"
        }
      ],
      typeDescriptions: {
        update_trip_definition: "Update Trip Definition",
        amend_trip_definition: "Amend Repeat Trips",
        cancel: "Cancel Trip(s)",
        recover: "Recover Trip(s)"
      }
    };
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
